import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgExpandText = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.5 14V9H6V12.5H9.5V14H4.5ZM13 9V5.5H9.5V4H14.5V9H13Z" })
});
export default SvgExpandText;
